<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                {{ treatyInfo1Label.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="name"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td class="text-xs-left">{{ row.item.riTypeDesc }}</td>
                    <td class="text-xs-left">{{ row.item.propNProp }}</td>
                    <td class="text-xs-left">{{ row.item.dispSeq }}</td>
                    <td class="text-xs-left">{{ row.item.infoLbl }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- <v-layout row wrap>
      <v-flex xs12>
      <v-expansion-panel :value="miscTreatyInfo1Panel" expand>
        <v-expansion-panel-content>
          <div slot="header">
            <v-icon>mdi-plus</v-icon>
            {{ newMode ? 'New Miscellaneous Treaty Information 1':'Edit Miscellaneous Treaty Information 1' }}
          </div>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-autocomplete :items="acctTypeList" :label="treatyInfo1Label.riType" v-model="treatyInfo1.riType" item-text="label" item-value="value" data-vv-name="riType" :data-vv-as="treatyInfo1Label.riType" :error-messages="errors.collect('riType')" v-validate="'entry'"></v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-autocomplete :items="propNPropList" :label="treatyInfo1Label.propNProp" v-model="treatyInfo1.propNProp" item-text="label" item-value="value" data-vv-name="propNProp" :data-vv-as="treatyInfo1Label.propNProp" :error-messages="errors.collect('propNProp')" v-validate="'required'" @change="doPropNProp"></v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-text-field :label="treatyInfo1Label.dispSeq" v-model="treatyInfo1.dispSeq" item-text="label" item-value="value" data-vv-name="dispSeq" :data-vv-as="treatyInfo1Label.dispSeq" :error-messages="errors.collect('dispSeq')" v-validate="'entry'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field :label="treatyInfo1Label.infoLbl" v-model="treatyInfo1.infoLbl" item-text="label" item-value="value" data-vv-name="infoLbl" :data-vv-as="treatyInfo1Label.infoLbl" :error-messages="errors.collect('infoLbl')" v-validate="'entry'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-flex lg6 md12 xs12>
            <v-card-actions >
              <v-btn class="white--text error" @click.prevent="doBack">
                Cancel
                <v-icon right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                Save
                <v-icon right>{{newMode? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-expansion-panel-content>
      </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
      </v-layout> -->
      <v-dialog v-model="showMiscTreatyInfo1Detail" width="1000px">
        <v-card>
          <!-- <div slot="header">
            <v-icon>mdi-plus</v-icon>
            {{ newMode ? 'New Miscellaneous Treaty Information 1':'Edit Miscellaneous Treaty Information 1' }}
          </div> -->
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon v-if="newMode">mdi-plus</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
            <v-toolbar-title v-if="newMode">New Miscellaneous Treaty Information 1</v-toolbar-title>
            <v-toolbar-title v-else>Edit Miscellaneous Treaty Information 1</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!-- <message :messages="messages"></message> -->
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg4 md4 xs12>
                  <v-autocomplete
                    :items="acctTypeList"
                    :label="treatyInfo1Label.riType"
                    v-model="treatyInfo1.riType"
                    item-text="label"
                    item-value="value"
                    data-vv-name="riType"
                    :data-vv-as="treatyInfo1Label.riType"
                    :error-messages="errors.collect('riType')"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 md4 xs12>
                  <v-autocomplete
                    :items="propNPropList"
                    :label="treatyInfo1Label.propNProp"
                    v-model="treatyInfo1.propNProp"
                    item-text="label"
                    item-value="value"
                    data-vv-name="propNProp"
                    :data-vv-as="treatyInfo1Label.propNProp"
                    :error-messages="errors.collect('propNProp')"
                    v-validate="'required'"
                    @change="doPropNProp"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 md4 xs12>
                  <v-text-field
                    :label="treatyInfo1Label.dispSeq"
                    v-model="treatyInfo1.dispSeq"
                    item-text="label"
                    item-value="value"
                    data-vv-name="dispSeq"
                    :data-vv-as="treatyInfo1Label.dispSeq"
                    :error-messages="errors.collect('dispSeq')"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 xs12>
                  <v-text-field
                    :label="treatyInfo1Label.infoLbl"
                    v-model="treatyInfo1.infoLbl"
                    item-text="label"
                    item-value="value"
                    data-vv-name="infoLbl"
                    :data-vv-as="treatyInfo1Label.infoLbl"
                    :error-messages="errors.collect('infoLbl')"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doBack">Cancel</v-btn>
            <v-btn color="primary" text @click.native="doSave">Save</v-btn>
          </v-card-actions>
          <!-- <v-flex lg6 md12 xs12>
            <v-card-actions >
              <v-btn class="white--text error" @click.prevent="doBack">
                Cancel
                <v-icon right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                Save
                <v-icon right>{{newMode? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-flex> -->
        </v-card>
      </v-dialog>
    </v-container>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure to delete the selected Miscellaneous Treaty Info 1 - {{ deleteMiscTreatyInfo1 }}
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { acctType, propNProp } from '@/const/params'
// import { mapGetters } from 'vuex'
// import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      newMode: true,
      reviewMode: false,
      submitting: false,
      promptRemove: false,
      showMiscTreatyInfo1Detail: false,
      deleteMiscTreatyInfo1: '',
      selectedMiscTreatyInfo1: undefined,
      miscTreatyInfo1Panel: [false],
      headers: [
        { text: 'RI Type', value: 'riType' },
        { text: 'Proportional / Non-Proportional', value: 'propNProp' },
        { text: 'Display Sequence No.', value: 'dispSeq' },
        { text: 'Information Label', value: 'infoLbl' },
        TableConst.tableActionHeader
      ],
      treatyInfo1Label: {
        riType: 'Inwards / Outwards',
        propNProp: 'Proportional or Non-Proportional',
        dispSeq: 'Display Sequence No.',
        infoLbl: 'Information Label',
        newButton: 'New Miscellaneous Treaty Information 1'
      },
      treatyInfo1: {
        riType: undefined,
        dispSeq: 0,
        infoLbl: undefined,
        propNProp: 'P',
        perPropTty: true,
        perNPropTty: false
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    doInit() {
      this.treatyInfo1.riType = this.riType
      this.doPropNProp()
      if (this.treatyInfo1.riType !== undefined) {
        this.miscTreatyInfo1Panel = [false]
      }
      this.miscTreatyInfo1List()
    },
    miscTreatyInfo1List() {
      this.resetMessages()
      const apiURI = this.treatyMenu.miscTreatyInfo1List
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((result) => {
                const convertList = {
                  riType: result.riType,
                  riTypeDesc: result.riTypeDesc,
                  propNProp: result.propNProp,
                  perPropTty: result.perPropTty,
                  perNPropTty: result.perNPropTty,
                  dispSeq: result.dispSeq,
                  infoLbl: result.infoLbl
                }
                this.items.push(convertList)
              })
            }
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
      this.loading = false
    },
    doPropNProp() {
      if (this.treatyInfo1.propNProp === 'P') {
        this.treatyInfo1.perPropTty = true
        this.treatyInfo1.perNPropTty = false
      } else if (this.treatyInfo1.propNProp === 'N') {
        this.treatyInfo1.perPropTty = false
        this.treatyInfo1.perNPropTty = true
      }
    },
    doNew() {
      this.newMode = true
      this.showMiscTreatyInfo1Detail = true
      this.miscTreatyInfo1Panel = [true]
      this.treatyInfo1.riType = 'O'
      this.treatyInfo1.propNProp = 'P'
      this.treatyInfo1.dispSeq = 0
      this.treatyInfo1.infoLbl = undefined
    },
    doReview(data) {
      this.showMiscTreatyInfo1Detail = true
      this.newMode = false
      this.miscTreatyInfo1Panel = [true]
      this.treatyInfo1.riType = data.riType
      if (data.perNPropTty === true) {
        this.treatyInfo1.propNProp = 'N'
      } else if (data.perPropTty === true) {
        this.treatyInfo1.propNProp = 'P'
      }
      // this.treatyInfo1.propNProp = data.propNProp
      this.treatyInfo1.dispSeq = data.dispSeq
      this.treatyInfo1.infoLbl = data.infoLbl
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
            // } else if (this.reviewMode) {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedMiscTreatyInfo1 = data
        this.deleteMiscTreatyInfo1 = data.riTypeDesc + ' - Display Sequence - ' + data.dispSeq
      }
    },
    doRemove() {
      const apiURI = this.treatyMenu.deleteMiscTreatyInfo1
      if (apiURI) {
        const expand = this.selectedMiscTreatyInfo1
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doBack() {
      this.showMiscTreatyInfo1Detail = false
      this.miscTreatyInfo1Panel = [false]
    },
    async doCreate() {
      const apiURI = this.treatyMenu.createMiscTreatyInfo1
      const form = this.treatyInfo1
      if (apiURI) {
        this.submitting = true
        try {
          // Starts here
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
          this.showMiscTreatyInfo1Detail = false
          this.doInit()
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.treatyMenu.updateMiscTreatyInfo1
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.treatyInfo1)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.showMiscTreatyInfo1Detail = false
          this.doInit()
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    treatyMenu() {
      return this.$store.state.treatyParam.menu
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    propNPropList() {
      let result = []
      Object.keys(propNProp).forEach(function (key) {
        const status = propNProp[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
    // ...mapGetters([
    //   'checkAccess'
    // ])
    // riType() {
    //   return this.$route.params.riType
    // },
    // ttyNo() {
    //   return this.$route.params.ttyNo
    // },
    // uwYr() {
    //   return this.$route.params.uwYr
    // }
  },
  created() {
    this.doInit()
  },
  props: ['riType', 'ttyNo', 'uwYr'],
  // props: {
  //   riType: {
  //     type: String,
  //     default: ''
  //   },
  //   ttyNo: {
  //     type: String,
  //     default: ''
  //   },
  //   uwYr: {
  //     type: String,
  //     default: ''
  //   }
  // },
  mixins: [
    TableConst.default,
    MessageMixin
    // routeMixin
  ]
}
</script>
